import { Timestamp } from 'firebase/firestore';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import { DateTime } from 'luxon';
import { TDR, toNearestCent, generateLineItem, generateSubtotalAdjLineItem } from 'tdr-common';

export function estimateInvoice<T>( policies: TDR.PricingPolicy<T>[], searchParameters: {
	groupSize: number;
	date: string;
	time: string;
}, tableId: string, restaurant: Partial<TDR.Restaurant>): Partial<TDR.Invoice<T>> {

	policies = sortBy([...policies], p => p.priority);
	const reservation = {
		items: [
			{
				type: TDR.Reservation.ItemType.Table,
				id: tableId
			}
		],
		time: getTimeFromFilters(searchParameters, restaurant.timezone),
		timezone: restaurant.timezone,
		restaurantId: restaurant.id,
		guests: searchParameters.groupSize,
		tableId: tableId
	} as Partial<TDR.Reservation<T>>;


	const lineItems = reservation.items.filter(item => item.type !== TDR.Reservation.ItemType.Coupon && item.type !== TDR.Reservation.ItemType.AddOn)
		.map(item => generateLineItem(policies, { reservation, item }))
		.filter(item => !isEmpty(item.charges));


	const totalBeforeDiscount = toNearestCent(
		lineItems.reduce((subtotal, lineItem) => subtotal + lineItem.total, 0)
	);
	const subtotal = totalBeforeDiscount;

	const subtotalAdjustmentLineItems = policies
		.map(policy => generateSubtotalAdjLineItem(policy, { reservation, invoice: { subtotal } }, subtotal)) // that invoice is NOT quite right
		.filter(item => !isEmpty(item.charges));

	// console.log('SUBTOTAL ITEMS', subtotalAdjustmentLineItems);

	const subtotalAdjustment = subtotalAdjustmentLineItems.reduce((adj, lineItem) => adj + (lineItem.total || 0), 0);
	const depositAdjustment = lineItems.reduce((adj, lineItem) => adj + (lineItem.deposit || 0), 0);
	const total = toNearestCent(subtotal + subtotalAdjustment + depositAdjustment);

	return {
		lineItems: lineItems,
		subtotal: subtotal,
		subtotalPriceAdjustments: subtotalAdjustmentLineItems,
		currency: restaurant.currency,
		total,
		deposit: depositAdjustment
	};
}

const DAY_FORMAT = 'yyyy-MM-dd';
const TIME_FORMAT = 'HH:mm';
const DATETIME_FORMAT = `${DAY_FORMAT} ${TIME_FORMAT}`;

function getTimeFromFilters(searchParams: TDR.Availability.searchParams, timezone): Timestamp | undefined {
	if (!searchParams) {
		return undefined;
	}

	if (searchParams.date) {
		const dateTime = DateTime.fromFormat(`${searchParams.date} ${searchParams.time}`, DATETIME_FORMAT, {
			zone: timezone
		});
		if (dateTime.isValid) {
			return Timestamp.fromMillis(dateTime.toMillis());
		}
	}
	return undefined;
}